import { render } from "./BlacklistOverview.vue?vue&type=template&id=900c0bb8&ts=true"
import script from "./BlacklistOverview.vue?vue&type=script&lang=ts"
export * from "./BlacklistOverview.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__